import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget, ModalComponent } from '../../../../widgets';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { oneActividadesExtrasAction } from '../actividades_extras/ActividadesExtrasAction';
import { getterReprobados } from '../plan_evaluacion/panel/components/EstadisticasPlanEvaluacion';
import {
  saveActExtraEstudiantesAction,
  setActivoActExtraEstudiantesAction,
} from './ActExtraEstudiantesAction';
import CardActExtraEstudiante from './components/CardActExtraEstudiante';
import ListadoActExtraEstudiantes from './components/ListadoActExtraEstudiantes';

const ActExtraEstudiantesView = () => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const [reprobados, setReprobados] = React.useState([]);
  const [loadingOne, setLoadingOne] = React.useState(false);

  const docentesStore = Redux.useSelector((state) => state.docentes);
  const usuEntidadesStore = Redux.useSelector((state) => state.usuEntidades);
  const actividadesExtrasStore = Redux.useSelector(
    (state) => state.actividadesExtras,
  );
  const actExtraEstudiantesStore = Redux.useSelector(
    (state) => state.actExtraEstudiantes,
  );
  const estudiantesStore = Redux.useSelector((state) => state.estudiantes);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );

  React.useEffect(
    () => {
      const reprobados = getterReprobados(
        actividadesExtrasStore.activo.tipo === 'RECUPERACION' ? 1 : 2,
        planEvaluacionStore.activo,
        entidadesStore.ajustes.ponderacion,
        estudiantesStore.allEstudiantesNotas,
      );
      setReprobados(reprobados);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoActExtraEstudiantesAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          mr={2}
          addIcon
          text="AGREGAR ESTUDIANTE"
        />
        <BotonComponent
          click={async () => {
            setLoadingOne(true);
            await setActivoActExtraEstudiantesAction(dispatch, null);
            await oneActividadesExtrasAction(
              dispatch,
              actividadesExtrasStore.activo.id,
            );
            setLoadingOne(false);
          }}
          white
          refreshIcon
          text={
            actExtraEstudiantesStore.loadingAll
              ? 'Actualizando...'
              : 'Actualizar'
          }
        />
      </Grid>
      <Grid item md={12}>
        {loadingOne ? (
          <LoadingWidget isLoading={loadingOne} />
        ) : (
          <ListadoActExtraEstudiantes
            setOpenModalForm={(value) => setOpenModalForm(value)}
          />
        )}
      </Grid>
      <ModalComponent
        id="modalFormActExtraEstudiantes"
        title="Asignar estudiante reprobado a la actividad extra"
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <Grid container spacing={2}>
          {reprobados.map((el) => {
            const find = actExtraEstudiantesStore.all.find(
              (item) => item.estudiante.id === el.id,
            );
            return (
              !find && (
                <Grid item xs={12} md={3}>
                  <CardActExtraEstudiante
                    estudiante={el}
                    isDelete={false}
                    isNota={false}
                    onAsignar={() => {
                      const res = saveActExtraEstudiantesAction(
                        {
                          dispatch,
                          notify,
                        },
                        actividadesExtrasStore.activo.id,
                        null,
                        {
                          idEstudiante: el.id,
                          idActividadExtra: actividadesExtrasStore.activo.id,
                          idDocente:
                            docentesStore.activo?.id ||
                            usuEntidadesStore.activo.id,
                          nota: '00',
                        },
                        null,
                      );
                      if (res) {
                        setOpenModalForm(false);
                      }
                    }}
                  />
                </Grid>
              )
            );
          })}
        </Grid>
      </ModalComponent>
    </Grid>
  );
};

export default ActExtraEstudiantesView;
